import styled from 'styled-components';

const YadoItemContentView = styled.div`
  flex: 1 1 auto;
  position: relative;
  padding: 16px;
  max-width: 400px;
  .title {
    margin: 0;
    padding: 0;
    color: var(--gray900);
    font-size: 1em;
    font-weight: 600;
  }
  .title-en {
    font-size: 10px;
    font-weight: 600;
    line-height: 1.6;
    padding: 0;
    margin: 0;
    color: var(--gray600);
  }
  .resort-more {
    display: inline-block;
    padding: 0;
    color: var(--gray900);
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    text-decoration: underline;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    .resort-more-modal {
      opacity: 0;
      background-color: var(--gray0);
      min-width: 360px;
      height: auto;
      border: 1px solid var(--gray600);
      position: absolute;
      z-index: 999;
      top: 32px;
      left: -2px;
      padding: 24px;
      border-radius: 8px;
      box-shadow: 0px 20px 20px 0 rgba(0, 0, 0, 0.2);
    }
    &:hover {
      overflow: inherit;
      .resort-more-modal {
        opacity: 1;
        top: 20px;
        transition: all 0.3s ease;
      }
    }
  }
`;

export default YadoItemContentView;
